// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__23s1K","label":"Section_label__1Ki0u","contentWrap":"Section_contentWrap__1p0ui","footer":"Section_footer__37VNz","footerInner":"Section_footerInner__uFZvM"};